class SpiSlideshow extends HTMLElement {
  connectedCallback() {
    this._tryInit();
  }

  _tryInit() {
    if (this._initialized) return;

    if (typeof Flickity === 'undefined') {
      // Flickity script is deferred — wait for it
      const check = setInterval(() => {
        if (typeof Flickity !== 'undefined') {
          clearInterval(check);
          this._init();
        }
      }, 50);
      return;
    }

    this._init();
  }

  _init() {
    if (this._initialized) return;
    this._initialized = true;

    this.slider = this.querySelector('.spi-flickity');
    if (!this.slider) return;

    const autoplay = this.dataset.autoplay === 'true';
    const speed = parseInt(this.dataset.speed || '5') * 1000;

    this.flkty = new Flickity(this.slider, {
      cellAlign: 'center',
      wrapAround: true,
      autoPlay: speed,        // sets the interval; we control start below
      pauseAutoPlayOnHover: true,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      selectedAttraction: 0.03,
      friction: 0.38,
      adaptiveHeight: false,
      setGallerySize: false
    });

    // Stop immediately then restart after layout settles
    this.flkty.stopPlayer();

    this.flkty.on('change', (index) => {
      this._handleVideo(index);
    });

    this._handleVideo(0);

    if (autoplay) {
      setTimeout(() => {
        if (this.flkty) this.flkty.playPlayer();
      }, 800);
    }
  }

  _handleVideo(activeIndex) {
    this.querySelectorAll('.spi-slide').forEach((slide, i) => {
      const video = slide.querySelector('video');
      if (!video) return;
      if (i === activeIndex) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }
}

if (!customElements.get('spi-slideshow')) {
  customElements.define('spi-slideshow', SpiSlideshow);
}
